


































































































































































import OrganizationSearch from '@/components/organization-search/index.vue';
import Vue from 'vue';
import { post, download } from '@root/utils/httpWrap';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import listPageMixin from '@root/common/mixins/list-page/list-page.vue';
import ParkingReviewImage from '@/components/parking-review-image/index.vue';
import inputNumberWithAddon from '@/components/input-number-with-addon/index.vue';
import { repaireRecordExamine } from '@/api/exception-management/index';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import PlateInput from '@/components/plate-input/index.vue';
import tableColumnData from './tableColumnData';
import detailDialog from '@/components/detail-dialog/index.vue';
import dataTransferCenter from './dataTransferCenter';
import { TRADE_RECORD_LIST } from '../../../../order-management/router-names';
import { TRADE_RECORD } from '../../../../fixed-car-management/router-names';
import filterParamFn from './filterParams';
import Utils from '@root/utils/common';
import { SpecialExitParkReasonMap } from '@/types/exception-management/dictionaries';
import moment from 'moment';
// 导入字典
import { longRentalStatusMap, propertyCarStatusMap } from '@/types/financial-management/dictionaries';

function transformParam(p: any) {
  return {
    ...p,
    userId: ''
  };
}

@Component({
  name: 'cleanCar',
  components: {
    OrganizationSearch,
    ParkingReviewImage,
    ParkingLotSearch,
    PlateInput,
    inputNumberWithAddon,
    detailDialog
  }
})
export default class repaireRecordRecord extends Mixins(listPageMixin) {
  private SpecialExitParkReasonList = Utils.toLabelVal(SpecialExitParkReasonMap);
  // 查询条件
  listRequestUrl = '';
  selfBus = new Vue();
  type = '';
  org = '';
  addHMSPostFix4TimeKey = false;
  status = '';
  date = '';
  dateTime = null;
  availableOrgs = null;
  userName = ''; // 账号
  realName = ''; // 真实姓名
  orgDepId: string[] | string | null = null; // 机构Id
  positionId: string = ''; // 岗位id
  searchValue = ''; // 查询条件内容值
  searchType = 'userName'; // 查询条件下拉框当前值
  positionOptions: IOption[] = []; // 岗位下拉选项
  selectedRows = [];
  initialTableColumnData = tableColumnData;
  // 查看图片弹框
  showReviewImgModel: boolean = false;
  //审核意见
  reviewDescriptionOfDialog = '';
  isEdit: boolean = false;
  viewImageModelData: Record<string, any> = {}; //查看图片所使用的视图数据
  tableData: any[] = []; // 表数据
  tableLoading: boolean = false;
  currentUser: Record<string, any> = {};

  @Prop()
  vm!: Record<string, any>;

  @Prop()
  businessType!: string;

  @Prop()
  exportResourseKey?: string;

  @Prop()
  tableRef?: string;
  customPrimaryUIConfig = {
    tableConfig: {
      operateColumn: false
    },
    detailDialog: {
      title: '临停收费报表'
    }
  };

  get computedPagination() {
    return {
      ...this.pagination,
      pageSize: this.pagination.pageSize,
      showTotal: () => `总共 ${this.totalRecordNumFromHttpRes} 条`
    };
  }

  // 统计颗粒度 00:日报  01:月报  02:季报  03:年报
  longRentalOptions: IOption[] = Utils.toLabelVal(longRentalStatusMap);
  // 车场运行状态，  01：正式运营 02：试运营  03：已停用
  propertyOptions: IOption[] = []
    .concat({
      label: '全部',
      value: ''
    })
    .concat(Utils.toLabelVal(propertyCarStatusMap));

  setOrgIdForFilterParam(useRootId = false) {
    let orgId = (!useRootId ? this.$route.query.orgId : undefined) || this.$store.state.organizations.userOrg[0].id;
    this.filterParam.org = orgId;

    if (useRootId) {
      this.$router.push(this.$route.fullPath.split('?')[0]);
    }
  }

  handleSearchWithRouteChange() {
    try {
      const route = this.getPushedRouteById(this.filterParam.org);
      const fullPath = this.$route.fullPath.split('?')[0];
      if (fullPath === route.split('?')[0]) {
        this.fetchTableData.apply(this, arguments);
      } else {
        this.$router.push(route);
      }
    } catch (e) {
      console.error(e);
    }
  }
  getPushedRouteById(id) {
    if (!id) {
      return this.$route.fullPath;
    }
    if (id == this.$route.query.orgId) {
      return this.$route.fullPath;
    }
    return this.$route.fullPath.split('?')[0] + '?orgId=' + id;
  }
  updateListRequestUrl() {
    if (this.businessType == 'temporary') {
      // 统计颗粒度 00:日报  01:月报  02:季报  03:年报
      this.listRequestUrl =
        '/bangdao/saasapi/v1' +
        {
          '00': '/temporaryOrg/dayReportList /temporaryPark/dayReportList'.split(' ')[this.vm.activeKey - 0],
          '01': '/temporaryOrg/monthReportList /temporaryPark/monthReportList'.split(' ')[this.vm.activeKey - 0]
        }[this.filterParam.type];
    } else if (this.businessType == 'fixed') {
      this.listRequestUrl =
        '/bangdao/saasapi/v1' +
        {
          '00': '/fixedOrg/dayReportList /fixedPark/dayReportList'.split(' ')[this.vm.activeKey - 0],
          '01': '/fixedOrg/monthReportList /fixedPark/monthReportList'.split(' ')[this.vm.activeKey - 0]
        }[this.filterParam.type];
    } else if (this.businessType == 'total') {
      this.listRequestUrl =
        '/bangdao/saasapi/v1' +
        {
          '00': '/reportOrg/dayReportList /reportPark/dayReportList'.split(' ')[this.vm.activeKey - 0],
          '01': '/reportOrg/monthReportList /reportPark/monthReportList'.split(' ')[this.vm.activeKey - 0]
        }[this.filterParam.type];
    }
  }

  get dialogCancelText() {
    return 'REVIEW' == this.detailDialogType ? '未通过' : '';
  }

  private requestHandler = {
    list(params: any): Promise<ProjectResponse<any>> {
      this.updateListRequestUrl();
      return post(this.listRequestUrl, transformParam(params));
    },
    export: (params: any): any => {
      if (this.businessType == 'total') {
        return download(
          `/bangdao/saasapi/v1/report${this.vm.activeKey == 0 ? 'Org' : 'Park'}/${
            this.vm.activeKey == 0 ? 'org' : 'park'
          }ReportExport`,
          transformParam(params),
          `总收费报表-${this.vm.activeKey == 0 ? '机构' : '车场'}维度`
        );
      } else {
        return download(
          `/bangdao/saasapi/v1/${this.businessType}${this.vm.activeKey == 0 ? 'Org' : 'Park'}/${
            this.vm.activeKey == 0 ? 'org' : 'park'
          }ReportExport`,
          transformParam(params),
          (this.businessType == 'fixed' ? '固定' : '临停') +
            // @ts-ignore
            `收费报表-${this.vm.activeKey == 0 ? '机构' : '车场'}维度`
        );
      }
    },
    exaimine: repaireRecordExamine
  };
  dataTransferCenter = dataTransferCenter;

  //filter-param
  private filterParam: any = {};

  /**
   * 车牌号组件发生变化
   */
  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  // 查看图片
  reviewImages(record: {}) {
    this.viewImageModelData = record;
    this.showReviewImgModel = true;
  }

  onTableFilterClearCallback() {
    this.setOrgIdForFilterParam(true);
    this.updateListRequestUrl();
    this.selfBus.$emit('B_TABLE_FILTER_CLEAR');
  }

  // 查询条件下拉框选项
  get searchOption() {
    return [
      {
        value: 'userName',
        label: '登录账号'
      },
      {
        value: 'realName',
        label: '真实姓名'
      }
    ];
  }

  onDetailDialogConfirm(nodeName: any) {
    this.onDetailDialogCancel(nodeName, '01');
  }

  async onDetailDialogCancel(nodeName: any, reviewStatus = '00') {
    if ('REVIEW' == this.detailDialogType && nodeName == 'BUTTON') {
      let row = this.getBasicInfoByDetailModel();
      let p = {
        // id: row.pkLiftId,
        id: row.pkReviseId,
        parkId: row.parkId,
        orderId: row.orderId,
        reviewStatus: reviewStatus,
        reviewDescription: this.reviewDescriptionOfDialog
      };

      await this.requestHandler.exaimine(p);
      this.$message.success('意见提交成功');
      // @ts-ignore
      this.$refs.detailDialog.hideDialog();
      this.fetchTableData();
    } else {
      // @ts-ignore
      this.$refs.detailDialog.hideDialog();
    }
  }

  get reviewColums() {
    return [
      {
        imageSrc: 'img',
        data: [
          {
            label: '车牌',
            dataIndex: 'plate'
          },
          {
            label: '入场时间',
            dataIndex: 'enterTime'
          },
          {
            label: '入场位置',
            dataIndex: 'enterChannelName'
          }
        ]
      }
    ];
  }

  // 所属车场树状图列表
  parkTree: any[] = [];
  getParkTreeDebounce: any = null;

  handleTypeChange() {
    var item = this.filterParam.adapterDataForViewModel.dateRangeHandler.list.find(
      it => it.value == this.filterParam.type
    );
    item.onChange(item.model);
  }

  created() {
    this.filterParam = filterParamFn.call(this);

    this.evtBus.$on('B_APP_READY', () => {
      this.$watch('$route.query.orgId', () => {
        this.setOrgIdForFilterParam();
        this.updateListRequestUrl();
      });

      this.setOrgIdForFilterParam();
      this.updateListRequestUrl();
    });
  }
}
